module.exports = __webpack_public_path__ + "img/阻力带踮脚跳.859aae62.png";